module.exports = __webpack_public_path__ + "img/art-test-icon4.964fb1fd.png";